// Гарын үсэг зурах талбар — хуруу (утас), хулгана, үзэгээр. Зурах бүрт onChange(PNG data URL), арилгахад onChange(null).
import React, { useEffect, useRef, useState } from "react";

export default function SignaturePad({ onChange, height = 160 }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [empty, setEmpty] = useState(true);

  // Дэлгэцийн нягтралд тааруулж канвасын хэмжээг тохируулна (өөрчлөгдөхөд арилна)
  useEffect(() => {
    const c = ref.current;
    const fit = () => {
      const r = c.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      c.width = Math.round(r.width * dpr);
      c.height = Math.round(r.height * dpr);
      const ctx = c.getContext("2d");
      ctx.scale(dpr, dpr);
      ctx.lineWidth = 2.2;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.strokeStyle = "#1a0b2e";
      setEmpty(true);
      onChange(null);
    };
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const point = (e) => {
    const r = ref.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    last.current = point(e);
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.arc(last.current.x, last.current.y, 1.1, 0, Math.PI * 2);
    ctx.fillStyle = "#1a0b2e";
    ctx.fill();
  };
  const move = (e) => {
    if (!drawing.current) return;
    const p = point(e);
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setEmpty(false);
    onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange(null);
  };

  return (
    <div className="flex flex-col gap-1.5">
      <div className="relative rounded-[14px] border-2 border-dashed border-[#d9cdea] bg-white">
        <canvas ref={ref} style={{ height, touchAction: "none" }} className="block w-full rounded-[12px] cursor-crosshair"
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} onPointerLeave={up} aria-label="Гарын үсэг зурах талбар" />
        {empty && <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-sm text-[#b8a9cf]">Энд гарын үсгээ зурна уу</span>}
        <span className="pointer-events-none absolute left-4 right-4 bottom-8 border-b border-[#ede0ff]" />
      </div>
      <div className="flex justify-end">
        <button type="button" onClick={clear} disabled={empty} className="text-sm font-semibold text-primary disabled:text-[#d9cdea] px-2 py-1">Арилгах</button>
      </div>
    </div>
  );
}
